import { AutoUnsubscriber } from '@library/classes/auto-unsubscriber/auto-unsubscriber';
import { QpLoggerService } from '@library/services/qp-logger/qp-logger.service';
import { ApplicationRef, inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

const ONE_HOUR = 60 * 60 * 1000;

/**
 * @description
 * Allow the app to stabilize first, before starting polling for updates with `interval()`.
 */
@Injectable({ providedIn: 'root' })
export class SwCheckForUpdateService extends AutoUnsubscriber {
  public readonly _swUpdate = inject(SwUpdate);
  public readonly _qpLoggerService = inject(QpLoggerService);
  private readonly _applicationRef: ApplicationRef = inject(ApplicationRef);

  public constructor() {
    super();
  }

  public init(): void {
    const appIsStable$ = this._applicationRef.isStable.pipe(first((isStable: Readonly<boolean>): boolean => isStable));
    const everyHours$ = interval(ONE_HOUR);
    const everyHoursOnceAppIsStable$ = concat(appIsStable$, everyHours$);

    this.registerSubscription(
      everyHoursOnceAppIsStable$.subscribe(
        (): void => {
          if (this._swUpdate.isEnabled) {
            void this._swUpdate.checkForUpdate();
          }
        },
        (error: Error): void => {
          this._qpLoggerService.error(error);
        }
      )
    );
  }
}
